import { Col, Form, Input, Row, Typography } from "antd";
import React from "react";
import moment from "moment";

const { Title } = Typography;

const formItemLayout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};

const transformData = (data) => {
  return data.map((item) => {
    const transformedItem = {
      question: item.question,
      questionType: item.questionType,
    };

    if (item.questionType === "YES_NO") {
      const answer = item.answers.find((answer) => answer.isCorrect);
      if (answer) {
        transformedItem.answer = answer.answerText;
      }
    } else if (item.questionType === "MULTIPLE_CHOICE") {
      transformedItem.options = {};
      const correctAnswer = item.answers.find((answer) => answer.isCorrect);

      item.answers.forEach((answer, index) => {
        transformedItem.options[(index + 1).toString()] = answer.answerText;
      });

      if (correctAnswer) {
        transformedItem.answer = `option${Object.keys(
          transformedItem.options
        ).find(
          (key) => transformedItem.options[key] === correctAnswer.answerText
        )}`;
      }
    } else if (item.questionType === "OPEN_ENDED") {
      const answer = item.answers[0];
      if (answer) {
        transformedItem.answer = answer.answerText;
      }
    }

    return transformedItem;
  });
};

function ViewQuiz({ data }) {
  return (
    <>
      <Form
        {...formItemLayout}
        name="view_quiz"
        initialValues={
          data
            ? {
                ...data,
                course: data.courseId.title,
                module: data.moduleId?.title,
                completionTime: moment(
                  data.completionTime,
                  moment.ISO_8601
                ).format("HH:mm:ss"),
                data: transformData(data.data),
              }
            : {}
        }
      >
        <Form.Item name="quizType" label="Quiz Associated with">
          <Input readOnly={true} />
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.quizType !== currentValues.quizType
          }
        >
          <Form.Item name="course" label="Course">
            <Input readOnly={true} />
          </Form.Item>
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.quizType !== currentValues.quizType
          }
        >
          {({ getFieldValue }) =>
            getFieldValue("quizType") === "module" ? (
              <Form.Item name="module" label="Module">
                <Input readOnly={true} />
              </Form.Item>
            ) : null
          }
        </Form.Item>
        <Form.Item name="releaseSchedule" label="Release on">
          <Input readOnly={true} />
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(prev, curr) =>
            prev.releaseSchedule !== curr.releaseSchedule
          }
        >
          {({ getFieldValue }) =>
            getFieldValue("releaseSchedule") === "Date" ? (
              <Form.Item name="releaseDate" label="Date">
                <Input readOnly={true} />
              </Form.Item>
            ) : getFieldValue("releaseSchedule") === "Days after enrollment" ? (
              <Form.Item
                name="numbersOfDaysToRelease"
                label="Days After Enrollment"
              >
                <Input readOnly={true} />
              </Form.Item>
            ) : null
          }
        </Form.Item>

        <Form.Item name="prerequisits" label="Prerequisite">
          <Input readOnly={true} />
        </Form.Item>

        <Form.Item name="passingPercentage" label="Passing Score(%)">
          <Input readOnly={true} />
        </Form.Item>

        <Form.Item name="questionPerPage" label="question Per Page">
          <Input readOnly={true} />
        </Form.Item>

        <Form.Item name="quizzCertiﬁcate" label="Certificate">
          <Input readOnly={true} />
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(prev, curr) =>
            prev.restriction_on_repetition !== curr.restriction_on_repetition
          }
        >
          <Form.Item name="repetations" label="Number of attempts">
            <Input readOnly={true} />
          </Form.Item>
        </Form.Item>

        <Form.Item name="completionTime" label="Auto Submit After">
          <Input readOnly={true} />
        </Form.Item>

        <Form.Item name="randomQuestions" label="Randomize questions?">
          <Input readOnly={true} />
        </Form.Item>

        <Form.Item name="randomAnswers" label="Randomize answers?">
          <Input readOnly={true} />
        </Form.Item>

        <Form.Item name="emailNotification" label="Email notification to user?">
          <Input readOnly={true} />
        </Form.Item>
        <Title level={3} style={{ textAlign: "center", marginBottom: "15px" }}>
          Quiz Questions:
        </Title>
        <Form.List
          name="data"
          rules={[
            {
              validator: async (_, questions) => {
                if (!questions || questions.length < 1) {
                  return Promise.reject(
                    new Error("At least 1 questions required")
                  );
                }
              },
            },
          ]}
        >
          {(fields) => (
            <>
              {fields.map(({ key, name }, index) => (
                <>
                  <Row gutter={16}>
                    <Col className="gutter-row" span={24} key={key}>
                      <Form.Item label="Question" name={[name, "question"]}>
                        <Input readOnly={true} />
                      </Form.Item>

                      <Form.Item
                        label="Question Type"
                        name={[name, "questionType"]}
                      >
                        <Input readOnly={true} />
                      </Form.Item>

                      <Form.Item
                        noStyle
                        shouldUpdate={(prev, curr) => {
                          return (
                            prev.data[index]?.questionType !==
                            curr.data[index]?.questionType
                          );
                        }}
                      >
                        {({ getFieldValue }) =>
                          getFieldValue(["data", index, "questionType"]) ===
                          "YES_NO" ? (
                            <Form.Item label="Answer" name={[name, "answer"]}>
                              <Input readOnly={true} />
                            </Form.Item>
                          ) : getFieldValue(["data", index, "questionType"]) ===
                            "OPEN_ENDED" ? (
                            <Form.Item label="Answer" name={[name, "answer"]}>
                              <Input readOnly={true} />
                            </Form.Item>
                          ) : getFieldValue(["data", index, "questionType"]) ===
                            "MULTIPLE_CHOICE" ? (
                            <>
                              {["1", "2", "3", "4"].map((item) => {
                                return (
                                  <Form.Item
                                    label={`option ${item}`}
                                    name={[name, "options", item]}
                                  >
                                    <Input readOnly={true} />
                                  </Form.Item>
                                );
                              })}
                              <Form.Item label="Answer" name={[name, "answer"]}>
                                <Input readOnly={true} />
                              </Form.Item>
                            </>
                          ) : null
                        }
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              ))}
            </>
          )}
        </Form.List>
      </Form>
    </>
  );
}

export default ViewQuiz;
